import { render, staticRenderFns } from "./DossierCover.vue?vue&type=template&id=62295c1d&scoped=true&"
import script from "./DossierCover.vue?vue&type=script&lang=js&"
export * from "./DossierCover.vue?vue&type=script&lang=js&"
import style0 from "./DossierCover.vue?vue&type=style&index=0&id=62295c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62295c1d",
  null
  
)

export default component.exports